/**
 * Simple Gift Card Recipient Form
 * No custom elements, just plain JavaScript
 */
(function() {
  'use strict';
  
  function initRecipientForm() {
    // Find all recipient forms on the page
    const forms = document.querySelectorAll('[data-recipient-form]');
    
    forms.forEach(function(formContainer) {
      const sectionId = formContainer.dataset.sectionId;
      const checkbox = document.getElementById('Recipient-checkbox-' + sectionId);
      const fieldsContainer = formContainer.querySelector('.recipient-fields');
      const inputs = formContainer.querySelectorAll('.recipient-fields input, .recipient-fields textarea');
      const offsetInput = document.getElementById('Recipient-timezone-offset-' + sectionId);
      
      if (!checkbox || !fieldsContainer) {
        console.error('Recipient form: Missing checkbox or fields container');
        return;
      }
      
      // Set timezone offset
      if (offsetInput) {
        offsetInput.value = new Date().getTimezoneOffset().toString();
      }
      
      // Function to toggle form visibility
      function toggleForm() {
        console.log('Checkbox toggled:', checkbox.checked);
        
        if (checkbox.checked) {
          // Show form and enable inputs
          fieldsContainer.classList.add('show');
          inputs.forEach(function(input) {
            input.disabled = false;
          });
          if (offsetInput) offsetInput.disabled = false;
        } else {
          // Hide form and disable inputs
          fieldsContainer.classList.remove('show');
          inputs.forEach(function(input) {
            input.disabled = true;
            input.value = '';
          });
          if (offsetInput) offsetInput.disabled = true;
        }
      }
      
      // Initialize form state
      toggleForm();
      
      // Listen for checkbox changes
      checkbox.addEventListener('change', toggleForm);
      
      console.log('Recipient form initialized for section:', sectionId);
    });
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRecipientForm);
  } else {
    initRecipientForm();
  }
})();
